import { render, staticRenderFns } from "./KT-Reminders.vue?vue&type=template&id=2d0abab5&lang=pug&"
import script from "./KT-Reminders.vue?vue&type=script&lang=js&"
export * from "./KT-Reminders.vue?vue&type=script&lang=js&"
import style0 from "./KT-Reminders.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports